import React from "react";
import { useEffect, useState } from "react";
import { BackgroundGradientAnimation } from "./ui/background-gradient-animation";
import { Button } from "./ui/moving-border";

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      {/* Mobile: simplified gradient background */}
      <div className="md:hidden absolute inset-0 overflow-hidden rounded-xl">
        <BackgroundGradientAnimation
          gradientBackgroundStart="#000000"
          gradientBackgroundEnd="#000000"
          firstColor="0,0,0"
          secondColor="252, 143, 65"
          thirdColor="255, 204, 168"
          fourthColor="252, 143, 65"
          fifthColor="86, 115, 205"
          pointerColor="140, 100, 255"
          size="100%"
          blendingValue="hard-light"
          interactive={false}
          containerClassName="w-full h-full rounded-xl"
        ></BackgroundGradientAnimation>
      </div>
      {/* Desktop: gradient + parallax images */}
      <div className="hidden md:flex flex-col -gap-8 absolute left-0 top-6 items-center w-screen rounded-xl">
        <BackgroundGradientAnimation
          gradientBackgroundStart="#000000"
          gradientBackgroundEnd="#000000"
          firstColor="0,0,0"
          secondColor="252, 143, 65"
          thirdColor="255, 204, 168"
          fourthColor="252, 143, 65"
          fifthColor="86, 115, 205"
          pointerColor="140, 100, 255"
          size="80%"
          blendingValue="hard-light"
          interactive={true}
          containerClassName="w-[97%] rounded-xl"
        ></BackgroundGradientAnimation>
        <div className="w-full -mb-6">
          <img
            src={"../lc1.png"}
            className="mr-auto z-10"
            alt="logo"
            style={{ transform: `translateY(${scrollY * 0.3}px)` }}
          />
        </div>
        <div className="w-full max-w-screen">
          <img
            src={"../rc1.png"}
            className="ml-auto z-10"
            alt="logo"
            style={{ transform: `translateY(${scrollY * 0.3}px)` }}
          />
        </div>
        <div className="w-full max-w-screen">
          <img
            src={"../lc2.png"}
            className="mr-auto z-10"
            alt="logo"
            style={{ transform: `translateY(${scrollY * 0.3}px)` }}
          />
        </div>
        <div className="w-full max-w-screen">
          <img
            src={"../rc22.png"}
            className="ml-auto z-10"
            alt="logo"
            style={{ transform: `translateY(${scrollY * 0.3}px)` }}
          />
        </div>
      </div>
      <div className="flex flex-col gap-4 md:gap-6 justify-center items-center min-h-[70vh] md:min-h-screen px-6 md:px-32 font-urbanist w-full relative md:top-10 md:py-0 mx-auto pt-20 md:pt-0 md:mb-0 mb-0">
        <h1
          className="md:text-[6rem] text-[2rem] leading-tight md:leading-[5.25rem] w-full text-white md:-mb-4 font-intvar font-[600] hero-title"
        >
          AI-Powered <span className="font-[900]">Market Research</span>, Instantly
          for Your Startup
        </h1>
        <div className="md:px-0 md:mx-2 md:pt-8 md:pb-2 rounded-xl z-20 flex flex-col justify-center items-center text-center md:gap-12 gap-4 py-4 relative">
          <p className="text-white md:text-[1.5rem] text-base w-full md:mb-6">
            Citrana provides market insights to help build ideas that sell.
          </p>
        </div>
        <div className="flex flex-row gap-2 md:gap-4 justify-center w-full sm:w-auto">
          <Button
            borderRadius="0.75rem"
            className="bg-glassbg bg-opacity-95 text-xs md:text-sm"
            containerClassName="h-11 md:h-14 w-auto"
            onClick={() =>
              document
                .getElementById("footer")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            <span className="px-3 md:px-5 whitespace-nowrap">Join The Waitlist!</span>
          </Button>
          <button
            className="bg-white text-black font-bold py-2 md:py-3 px-4 md:px-6 rounded-xl hover:bg-gray-200 transition-all duration-300 text-xs md:text-base whitespace-nowrap"
            onClick={() =>
              window.location.href = "https://citrana-beta.netlify.app"
            }
          >
            Try the Beta
          </button>
        </div>
      </div>
    </>
  );
};

export default Hero;
